import React from "react";
import Helmet from "react-helmet";
import JSONData from "branding/site-metadata.json";
import "./footer-page.css";

export default function FooterPageLayout({ children, title }) {
  return (
    <div>
      <Helmet data={JSONData}>
        <title>{title}</title>
      </Helmet>
      
      {/* Branded Header */}
      <header>
        <a href="/">
          <img 
            src="/img/bold_logo.png" 
            alt="Bold Logo" 
          />
        </a>
      </header>

      {/* Main Content */}
      <main>
        {children}
      </main>

      {/* Footer with Links */}
      <footer>
        <div style={{ marginBottom: '10px' }}>
          <a href="/">Home</a>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
          <a href="/end-license-user-agreement">End User License Agreement</a>
          <a href="https://app.termly.io/notify/f74dab8f-2de7-4114-bd7d-25ecf7836712" target="_blank">Do Not Sell My Personal Information</a>
          <a href="/contact-us">Contact Us</a>
        </div>
        <div style={{ fontSize: '12px', color: '#666' }}>
          © {new Date().getFullYear()} Bold. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
